import { render, staticRenderFns } from "./SociosHorarioExtraescolares.vue?vue&type=template&id=f794e91c&scoped=true&"
import script from "./SociosHorarioExtraescolares.vue?vue&type=script&lang=js&"
export * from "./SociosHorarioExtraescolares.vue?vue&type=script&lang=js&"
import style0 from "./SociosHorarioExtraescolares.vue?vue&type=style&index=0&id=f794e91c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f794e91c",
  null
  
)

export default component.exports